import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import { RFI_CREATE_STEPS } from '../../utils';

import './RfiCreateActions.styles.scss';

type RfiCreateActionsProps = {
  className?: string;
  step: number;
  nextDisabled?: boolean;
  submitDisabled?: boolean;
  submitLabel?: string;
  needsAttentionCount?: number;
  onNext: () => void;
  onBack: () => void;
};

const RfiCreateActions: React.FC<RfiCreateActionsProps> = (props) => {
  const {
    className,
    step,
    nextDisabled,
    submitDisabled,
    submitLabel,
    needsAttentionCount,
    onNext,
    onBack,
  } = props;

  const { t } = useTranslation();

  const classes = classNames('rfi-create-actions', className);

  return (
    <div className={classes}>
      <div className="rfi-create-actions__row">
        {step === RFI_CREATE_STEPS.DOCUMENTS ? (
          <Button type="button" disabled={nextDisabled} onClick={onNext}>
            {t('continue')}
          </Button>
        ) : (
          <>
            <Button type="button" variant="outline" onClick={onBack}>
              {t('back')}
            </Button>
            <Button type="submit" disabled={submitDisabled}>
              {t(submitLabel || 'createRequest')}
            </Button>
          </>
        )}
      </div>

      {step === RFI_CREATE_STEPS.DOCUMENTS && !!needsAttentionCount && (
        <p className="rfi-create-actions__needs-attention">
          {t('documentsNeedAttentionWontBeAdded', {
            count: needsAttentionCount,
          })}
        </p>
      )}
    </div>
  );
};

export default RfiCreateActions;
